/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachedDocumentResponse
 */
export interface AttachedDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof AttachedDocumentResponse
     */
    documentId: string;
    /**
     * 
     * @type {string}
     * @memberof AttachedDocumentResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof AttachedDocumentResponse
     */
    contentType: string;
}

/**
 * Check if a given object implements the AttachedDocumentResponse interface.
 */
export function instanceOfAttachedDocumentResponse(value: object): value is AttachedDocumentResponse {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function AttachedDocumentResponseFromJSON(json: any): AttachedDocumentResponse {
    return AttachedDocumentResponseFromJSONTyped(json, false);
}

export function AttachedDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachedDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'fileName': json['fileName'],
        'contentType': json['contentType'],
    };
}

export function AttachedDocumentResponseToJSON(json: any): AttachedDocumentResponse {
    return AttachedDocumentResponseToJSONTyped(json, false);
}

export function AttachedDocumentResponseToJSONTyped(value?: AttachedDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'fileName': value['fileName'],
        'contentType': value['contentType'],
    };
}

